import * as React from "react";
import { QESButton } from "./qes-standards";

interface FileInputProps {
  onSubmitFile: (data: FormData) => Promise<unknown>;
}

export default class FileInput extends React.Component<FileInputProps> {
  private fileInput: React.RefObject<HTMLInputElement>;

  constructor(props: FileInputProps) {
    super(props);
    this.fileInput = React.createRef();
  }

  public render() {
    return (
      <form onSubmit={this.handleSubmit} action="/app/v2.0/regionsets/translateserviceareaintoregionset" encType="multipart/form-data" method="post" className="file-input-form">
        <div className="custom-file left">
          <input type="file" className="form-control custom-file-input" id="tf3" accept=".qsa" ref={this.fileInput} />
          <label className="custom-file-label" htmlFor="tf3">Choose Service Area file (*qsa)</label>
        </div>
        <QESButton qesTestId="service-area-file-input_upload" qesType="primary" className="upload" id="submit" type="submit"><i className="fa fa-upload" /> Upload</QESButton>
      </form>
    );
  }

  private handleSubmit = async (event: { preventDefault: () => void; }) => {
    const data = new FormData();
    event.preventDefault();

    data.append("serviceAreaFile", this.fileInput.current.files[0]);

    this.props.onSubmitFile(data);
  }
}
